type ContactTranslate = (key: string, options?: { ns?: string; defaultValue?: string }) => string;

const FIELD_KEYS: Record<string, string> = {
  email: 'email',
  firstname: 'firstName',
  lastname: 'lastName',
  name: 'name',
  phone: 'phone',
  phonenumber: 'phone',
  whatsapp: 'whatsApp',
  title: 'titleField',
  language: 'language',
  channels: 'channels',
  status: 'status',
  reminderpreference: 'reminderPreference',
  marketingemails: 'marketingEmails',
  value: 'channelValue',
  label: 'channelLabel',
  type: 'channelType',
};

export const contactFieldLabel = (field: string, t: ContactTranslate): string => {
  const normalized = field.trim();
  const channelMatch = normalized.match(/^channels\[(\d+)\]\.(value|label|type)$/i);
  if (channelMatch) {
    const part = channelMatch[2].toLowerCase();
    const key = part === 'value' ? 'channelValue' : part === 'label' ? 'channelLabel' : 'channelType';
    return `${t(key, { ns: 'contacts' })} ${Number(channelMatch[1]) + 1}`;
  }

  const key = FIELD_KEYS[normalized.replace(/[\s._]/g, '').toLowerCase()];
  return key ? t(key, { ns: 'contacts' }) : normalized;
};

export const formatContactApiError = (message: string, t: ContactTranslate): string =>
  message.replace(/(^|;\s*)([^:;]+):/g, (_match, prefix: string, field: string) => (
    `${prefix}${contactFieldLabel(field, t)}:`
  ));

export const contactStatusLabel = (value: string, t: ContactTranslate, fallback?: string): string =>
  t(`statusOptions.${value}`, { ns: 'contacts', defaultValue: fallback || value });

export const contactReminderLabel = (value: string, t: ContactTranslate, fallback?: string): string =>
  t(`reminderPreferenceOptions.${value}`, { ns: 'contacts', defaultValue: fallback || value });

export const contactLanguageLabel = (value: string, t: ContactTranslate, fallback?: string): string =>
  t(`languageOptions.${value}`, { ns: 'contacts', defaultValue: fallback || value });
